import React, { Component } from 'react';
import { Grid, Card, Table, Button, Input, Dropdown, Icon } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Buttons from '@material-ui/core/Button';
import Setexecutive from './executive';
import Loading from '../../loading';
import Tables from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import './upidetails.css';
import Delete from '@material-ui/icons/Delete';
import Create from '@material-ui/icons/Create';
import Errordialog from '../../errordialog';

class Customer extends Component {

  state = {
    opendialog: false,
    load: false,
    executives: []
  }

  removeBankDetails() {
    let context = this;
    let id = this.state.deleteid;
    let data = {'id': id};
    context.setState({
      load: true,
      opendialog: false,
      message: 'Removing Upi Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'upidetails/delete.php',
      success: function(data)
      {
        if (data == 1) {
          context.update(id);
          context.setState({
            load: false,
          })
        }
        else {
          context.setState({ load: false, errorDialog: true, errormessage: 'Faild to Remove!!' })
        }
      },
      error: function(e)
      {
        alert('Try again!!!')
        context.setState({
          load: false,
        })
      }
    });
  }

  update(id) {
    let data = this.props.data;
    let dele = [];
    data.map((del) => {
      if (del.id == id) {
        return;
      }
      else {
        dele.push(del);
      }
    });
    this.props.updateData(dele);
  }

  delete(id) {
    this.setState({
      opendialog: true,
      deleteid: id
    })
  }

  edit(id, upi) {
    this.setState({
      openEdit: true,
      id: id,
      upi: upi
    })
  }

  handleClose(){
    this.setState({
      opendialog: false
    })
  }

  closeedit() {
    this.setState({
      openEdit: false
    })
  }

  updatedetails(){
    let context = this;
    let id = this.state.id;
    let name = this.state.upi;
    if (name == '' || name == undefined || name == null) {
      alert('Enter the UPI!!!');
      return;
    }
    let olddata = context.props.data;
    let data = {'id': id, 'upi': name};
    context.setState({
      load: true,
      message: 'Updating   Upi Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'upidetails/update.php',
      success: function(data)
      {
        context.setState({
          openEdit: false,
          load: false
        })
        if (data == 1) {
          for (var i = 0; i < olddata.length; i++) {
            if (id == olddata[i].id) {
              olddata[i].upi = name;
            }
          }
          context.props.updateData(olddata);
        }
        else {
          context.setState({ load: false, errorDialog: true, errormessage: 'Faild to Update!!' })
        }
      },
      error: function(e)
      {
        alert('Try again!!!')
        context.setState({
          load: false,
        })
      }
    });
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  closeErrorDialog() {
    this.setState({ errorDialog: false });
  }

  render() {
    const { fullScreen } = this.props;
    let { opendialog, openEdit, executive, load, message } = this.state;
    let dialog, edit;
    if(opendialog) {
      dialog = (
        <Dialog open={opendialog} onClose={this.handleClose.bind(this)}
            aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">{"Alert"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Dont you want remove
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Buttons onClick={this.handleClose.bind(this)} color="secondary">
                NO
              </Buttons>
              <Buttons onClick={this.removeBankDetails.bind(this, this.props.id)} color="primary" autoFocus>
                Yes
              </Buttons>
            </DialogActions>
          </Dialog>
      )
    }
    return (
      <div>
        <Loading load={load} message={message} />
        <Paper>
          <table width='100%' id='emp_table'>
            <tr id='tableheader'>
              <th id='tablecolumn'><b>S.No</b></th>
              <th id='tablecolumn'><b>UPI</b></th>
              <th id='tablecolumn'><b>Executive</b></th>
              {
                this.props.menuPermission.edit ?
                <th id='tablecolumn'><b>Edit</b></th>: ''
              }
              {
                this.props.menuPermission.cancel ?
                <th id='tablecolumn'><b>Delete</b></th>: ''
              }
              
              
            </tr>
              {this.props.data.map((z) => {
                  if (z.type == 'upi') {
                    return (
                      <tr id='tablerow'>
                        <td style={{fontSize: 14, width: '5%'}}><center>{z.sino}</center></td>
                        <td style={{fontSize: 14}}>{z.upi}</td>
                        <td style={{fontSize: 14}}>
                          <Setexecutive menuPermission={this.props.menuPermission} data={this.props.data} upieditcontrol={this.props.upieditcontrol}
                            executive={this.props.executive} id={z.id} viewEdit={this.props.viewEdit} />
                        </td>
                        {
                          this.props.menuPermission.edit ?
                          <td style={{fontSize: 12, cursor: 'pointer', width: '5%',
                                    marginLeft: 'auto', marginRight: 'auto'}}
                                    onClick={this.edit.bind(this, z.id, z.upi)}>
                          <center>Edit</center>
                        </td>: ''
                        }
                        {
                          this.props.menuPermission.cancel ?
                          <td style={{fontSize: 12, cursor: 'pointer', width: '5%'}}
                              onClick={this.delete.bind(this, z.id)}>
                            <center>Delete</center>
                          </td>: ''
                        }
                        
                      </tr>
                    );
                  }
                }
              )}
          </table>
          <Errordialog load={this.state.errorDialog} message={this.state.errormessage} close={this.closeErrorDialog.bind(this)} />
        </Paper>
        <Dialog fullScreen={fullScreen} open={openEdit}
         onClose={this.handleClose.bind(this)} aria-labelledby="responsive-dialog-title">
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>{"Update UPI"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                UPI Name<br/>
                <Input value={this.state.upi} fluid focus
                  onChange={this.onChange('upi')}
                  placeholder='UPI' />
              </Grid.Column>
            </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={this.closeedit.bind(this)} color="secondary">
              Cancel
            </Buttons>
            <Buttons onClick={this.updatedetails.bind(this)} color="primary" autoFocus>
              Submit
            </Buttons>
          </DialogActions>
        </Dialog>
      {dialog}
      </div>
    );
  }
}

export default Customer;
